// 渲染文字
import React, { memo } from 'react'
import styled from 'styled-components'
import { replaceSrc } from "../../utils/utils"

const TextMsgOrd = styled.span`
  display: inline-block;
  margin-top: 8px;
  padding: 16px;
  background: var(--message-bgc-left);
  border-radius: 8px;
  color: var(--message-font-left);
`
const TextMsgRecall = styled.span`
  display: inline-block;
  margin-top: 8px;
  padding: 16px;
  background: var(--message-bgc-left);
  border-radius: 8px;
  color: var(--message-font-left);
`
const RenderTextMsg = memo((props) => { //侧边栏搜索关键词需要高亮显示，在此区分
  const { value } = props
  // console.log(props)
  let message = value.messageContent ? JSON.parse(value.messageContent) : {}
  // 2撤回
  // TODO: 考虑防注入
  return (
    !value.revoked ?
      <TextMsgOrd dangerouslySetInnerHTML={{ __html: replaceSrc(message.content) }}
        style={value.sendType === 2 ? { background: "var(--message-bgc-right)" } : {}}
      />
      : <TextMsgRecall dangerouslySetInnerHTML={{ __html: replaceSrc(message.content) }}
        style={value.sendType === 2 ? { background: "var(--message-bgc-right)" } : {}}
      />
  )
})

export default RenderTextMsg
